import React from "react";
import { useTranslation } from "react-i18next";
// eslint-disable-next-line camelcase
import { atcb_action } from "add-to-calendar-button-react";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc";
import { Button } from "@companion-core/shared/app/Components/Button";
import { getModule } from "@companion-core/shared/app/Utils/config";
import { AddToCalendarButtonProps } from "@companion-core/shared/app/Components/Requests/RequestDetail/AddToCalendarButton/AddToCalendarButton.model";
import {
  formatDateToHHmmFormat,
  formatDateToISOFormat,
  isValidDate,
} from "@companion-core/shared/app/Utils/datetime";
import { useRequestCard } from "@companion-core/shared/app/Components/Requests/RequestCard/hooks/useRequestCard";
dayjs.extend(localizedFormat);
dayjs.extend(utc);

export const AddToCalendarButton = ({ requestData, location }: AddToCalendarButtonProps) => {
  const { t } = useTranslation();
  const addToCalendarConfig = getModule("concierge")?.modules?.AddToCalendar;
  const calendarIcon = addToCalendarConfig?.addToCalendarIcon ?? "JP-Calendar";
  const calendarOptions = addToCalendarConfig?.webOptions ?? ["Google", "iCal"];
  const categoryConfig = addToCalendarConfig?.categories?.[requestData.family ?? ""];
  const subCategoryConfig = categoryConfig?.subcategories?.[requestData.sub_family ?? ""];
  const sendTime =
    subCategoryConfig?.sendStartTime ??
    categoryConfig?.sendStartTime ??
    addToCalendarConfig?.sendStartTime;
  const sendEndDate =
    subCategoryConfig?.sendEndDate ??
    categoryConfig?.sendEndDate ??
    addToCalendarConfig?.sendEndDate;
  const displayAddToCalendarButton =
    subCategoryConfig?.displayButtonOnWeb ??
    categoryConfig?.displayButtonOnWeb ??
    addToCalendarConfig?.displayButtonOnWeb;

  const { detailTitle } = useRequestCard(requestData);
  const rawStartDate = requestData.start_date ?? "";
  const rawEndDate = requestData.end_date ?? "";
  const startDate = formatDateToISOFormat(rawStartDate);
  const endDate = isValidDate(rawEndDate)
    ? formatDateToISOFormat(rawEndDate)
    : formatDateToISOFormat(rawStartDate);
  // In case if we don't receive an end_date from the crm
  const startTime = formatDateToHHmmFormat(rawStartDate);
  const endTime = isValidDate(rawEndDate)
    ? formatDateToHHmmFormat(rawEndDate)
    : formatDateToHHmmFormat(rawStartDate);
  const timeZone = requestData?.location
    ? requestData?.location?.timeZone
    : requestData?.start_location?.timeZone;

  const handleAddToCalendarClick = () => {
    atcb_action({
      name: detailTitle,
      startDate: startDate,
      ...(sendTime && {
        startTime: startTime,
      }),
      ...(sendEndDate && {
        endDate: endDate,
      }),
      // In web we can't send startTime without sending endTime
      ...(sendTime && {
        endTime: endTime,
      }),
      location: location,
      ...(timeZone && { timeZone: timeZone }),
      options: calendarOptions,
    });
  };

  return (
    <>
      {displayAddToCalendarButton && (
        <div className="request-detail__add-to-calendar-button__container">
          <Button
            icon={calendarIcon}
            testID="request-detail__add-to-calendar-button"
            classNames={["request-detail__add-to-calendar-button body-text-6"]}
            type="secondary"
            size="large"
            label={t("request.my-requests.detail.button.add-to-calendar.label")}
            onClick={handleAddToCalendarClick}
          />
        </div>
      )}
    </>
  );
};
